import styled from 'styled-components';

export const StyledSelector = styled.div`
  margin-top: -5px;
  margin-bottom: 5px;
  background-color: #f6f6f6;
  .ant-select-selection-item {
    font-weight: 600;
    font-size: 18px;
  }
`
